import React, { useState } from "react";
import { Dropdown, Form } from "react-bootstrap";
import { PaginationItem } from "@preveil-api";
import { CheckboxStates } from "src/common";
import { ToolbarWrapper, ToolbarButton, ToolbarFilter, Icon, ToolbarDropdownItem, Checkbox, Pagination, SimplePagination } from "src/components";

// Description: UI guide showcase for the ToolbarWrapper component, demonstrating its variations (filter, pagination, dropdown items, disabled state).
function ToolbarComponent() {
  const [is_loading, setIsLoading] = useState(false);

  const sample_pagination_item: PaginationItem = {
    pageIndex: 0,
    pageSize: 10,
    pageCount: 100,
    totalRows: 1000,
    offset: 0,
    isLastPage: false
  };

  const pagination = (
    <Pagination
      pagination={sample_pagination_item}
      handleAction={() => {}}
    />
  );

  const simple_pagination = (
    <SimplePagination
      isFirst={false}
      isLast={false}
      handleAction={() => {}}
    />
  );

  const menu = (
    <>
      <label>Topic:</label>
      <Dropdown className="pv-dropdown me-2">
        <Dropdown.Toggle variant="link" className="btn btn-sm py-0">
          Topic
        </Dropdown.Toggle>
        <Dropdown.Menu flip={true} className="p-0" align="end">
          <Dropdown.Item onClick={() => {}}>Topic 1</Dropdown.Item>
          <Dropdown.Item onClick={() => {}}>Topic 2</Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
      <>
        <label>Action:</label>
        <Dropdown className="pv-dropdown">
          <Dropdown.Toggle variant="link" className="btn btn-sm py-0">
            Action
          </Dropdown.Toggle>
          <Dropdown.Menu flip={true} className="p-0" align="end">
            <Dropdown.Item onClick={() => {}}>Action 1</Dropdown.Item>
            <Dropdown.Item onClick={() => {}}>Action 2</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </>
    </>
  );

  const form = (
    <Form.Select size="sm" onChange={() => {}}>
      <option value={"all"}>
        All
      </option>
      <option value={"hidden"}>
        Hidden
      </option>
      <option value={"shown"}>
        In My PreVeil
      </option>
    </Form.Select>
  );

  const checkbox = (
    <>
      <Checkbox className="sr-only"
        onChange={() => {}}
        value="all" label="Select All" selected={CheckboxStates.checked}
      />
      <span className="divider" />
    </>
  );

  return <>
    <h4>Toolbar</h4>

    <ToolbarWrapper
      leftContent={checkbox}
      pagination={pagination}
      paginationInfo={<span>1-10 of 1000</span>}
      refreshAction={() => {setIsLoading(!is_loading);}}
      isLoading={is_loading}
    >
      <ToolbarButton tooltipContent="Enabled Button" ariaLabel="Enable" onClick={() => {console.log("Enabled Button clicked");}}>
        <Icon className="ficon-check" />
      </ToolbarButton>
      <ToolbarButton tooltipContent="Disabled Button" ariaLabel="Disable" disabled={true} onClick={() => {console.log("ERROR: Disabled Button clicked");}}>
        <Icon className="ficon-x" />
      </ToolbarButton>
      <ToolbarButton tooltipContent="Sample Button 1" ariaLabel="Sample Button 1" onClick={() => {console.log("Sample Button 1 clicked");}}>
        <Icon className="ficon-facebook" />
      </ToolbarButton>
      <span className="divider" />
      <ToolbarButton tooltipContent="Sample Button 2" ariaLabel="Sample Button 2" onClick={() => {console.log("Sample Button 2 clicked");}}>
        <Icon className="ficon-github" />
      </ToolbarButton>
      <ToolbarButton tooltipContent="Sample Button 3" ariaLabel="Sample Button 3" onClick={() => {console.log("Sample Button 3 clicked");}}>
        <Icon className="ficon-twitch" />
      </ToolbarButton>
      <ToolbarDropdownItem tooltipContent="Enabled Dropdown Item" onClick={() => {console.log("Enabled Dropdown Item clicked");}}>
        Enable
      </ToolbarDropdownItem>
      <ToolbarDropdownItem tooltipContent="Disabled Dropdown Item" disabled={true} onClick={() => {console.log("ERROR: Disabled Dropdown Item clicked");}}>
        Disable
      </ToolbarDropdownItem>
    </ToolbarWrapper>
    <br />

    <ToolbarWrapper
      leftContent={<ToolbarFilter disabled={false} filter_param="" onChange={() => {}} onClick={() => {}} />}
      pagination={simple_pagination}
      paginationInfo={<span>1-10 of 1000</span>}
      refreshAction={() => {setIsLoading(!is_loading);}}
      isLoading={is_loading}
    >
      <ToolbarButton tooltipContent="Enabled Button" ariaLabel="Enable" onClick={() => {console.log("Enabled Button clicked");}}>
        <Icon className="ficon-check" />
      </ToolbarButton>
      <ToolbarButton tooltipContent="Disabled Button" ariaLabel="Disable" disabled={true} onClick={() => {console.log("ERROR: Disabled Button clicked");}}>
        <Icon className="ficon-x" />
      </ToolbarButton>
      <ToolbarDropdownItem tooltipContent="Enabled Dropdown Item" onClick={() => {console.log("Enabled Dropdown Item clicked");}}>
        Enable
      </ToolbarDropdownItem>
      <ToolbarDropdownItem tooltipContent="Disabled Dropdown Item" disabled={true} onClick={() => {console.log("ERROR: Disabled Dropdown Item clicked");}}>
        Disable
      </ToolbarDropdownItem>
    </ToolbarWrapper>
    <br />

    <ToolbarWrapper
      leftContent={menu}
      pagination={simple_pagination}
      paginationInfo={<span>1-10 of 1000</span>}
      refreshAction={() => {setIsLoading(!is_loading);}}
      isLoading={is_loading}
    >
      <></>
    </ToolbarWrapper>
    <br />

    <ToolbarWrapper
      leftContent={form}
      paginationInfo={<span>10 Items</span>}
      refreshAction={() => {setIsLoading(!is_loading);}}
      isLoading={is_loading}
    >
      <></>
    </ToolbarWrapper>
    <br />

    <ToolbarWrapper
      leftContent={<ToolbarFilter disabled={false} filter_param="" onChange={() => {}} onClick={() => {}} />}
      refreshAction={() => {setIsLoading(!is_loading);}}
      isLoading={is_loading}
      disabled={true}
    >
      <ToolbarButton tooltipContent="Enabled Button" ariaLabel="Enable" onClick={() => {console.log("Enabled Button clicked");}}>
        <Icon className="ficon-check" />
      </ToolbarButton>
      <ToolbarButton tooltipContent="Disabled Button" ariaLabel="Disable" disabled={true} onClick={() => {console.log("ERROR: Disabled Button clicked");}}>
        <Icon className="ficon-x" />
      </ToolbarButton>
      <ToolbarDropdownItem tooltipContent="Enabled Dropdown Item" onClick={() => {console.log("Enabled Dropdown Item clicked");}}>
        Enable
      </ToolbarDropdownItem>
      <ToolbarDropdownItem tooltipContent="Disabled Dropdown Item" disabled={true} onClick={() => {console.log("ERROR: Disabled Dropdown Item clicked");}}>
        Disable
      </ToolbarDropdownItem>
    </ToolbarWrapper>
  </>;
}

export default React.memo(ToolbarComponent);
